import type React from 'react';
import type { PropsWithChildren } from 'react';

interface Props {
  /**
   * Condition to evaluate. If truthy will return the component
   */
  if?: any;
}

type VisibleProps = PropsWithChildren<Props>;
/**
 * Render a component if the `if` prop evaluates to true, ensures we render `null` in cases where
 * the result is undefined to prevent crashing on native
 */
export const Visible: React.FC<VisibleProps> = ({ if: cond, children }) => {
  if (!cond) {
    return null;
  }

  return <>{children}</>;
};
